<template>
  <div class="about">
    <div class="head">
      <span style="float: left; line-height: 55px">
        <i class="el-icon-arrow-left" @click="$router.back(-1)"></i>银行卡列表</span
      >
      <div id="box" ref="box">
        <div class="marquee-box" ref="marquee" @mouseover="menter" @mouseleave="mleave">
          <p ref="cmdlist" id="pWidth" @click="detail(i)">
            <i class="el-icon-s-flag" style="color: red"></i>{{ gg }}
          </p>
        </div>
      </div>
      <img :src="imge" width="40" height="40" class="touimg" />
      <!-- <el-card class="notice">
        <el-carousel
          indicator-position="none"
          arrow="never"
          direction="horizontal"
          :interval="6000"
          :loop="true"
        >
          <el-carousel-item v-for="(i, ind) in newlist" :key="ind" class="notice_item">
            <i class="el-icon-s-flag" style="color: red"></i
            ><span @click="detail(i)" style="cursor: pointer"> {{ i.title }}</span>
          </el-carousel-item>
        </el-carousel>
      </el-card> -->
      <h2 class="spname">{{ shopname }}[{{ dptype }}]</h2>
    </div>
    <!-- <el-date-picker v-model="start" type="date" placeholder="开始日期">
		</el-date-picker> 至
		<el-date-picker v-model="end" type="date" placeholder="结束日期">
		</el-date-picker>-->
    <!-- <label for="" style="margin-left: 20px">账号：</label>
    <el-input placeholder="请输入内容" v-model="input" style="width: 200px" clearable>
    </el-input> -->
    <label for="" style="margin-left: 20px">卡号：</label>
    <el-input placeholder="请输入内容" v-model="cardinput" style="width: 200px" clearable>
    </el-input>
    <!-- <label for="" style="margin-left: 20px">姓名：</label>
    <el-input placeholder="请输入内容" v-model="nameinput" style="width: 150px" clearable>
    </el-input> -->
    <el-button type="warning" @click="getUser" style="margin-left: 20px">查看</el-button>
    <el-button type="warning" @click="add" style="margin-left: 20px">添加</el-button>
    <br /><br />
    <!-- 内容区域 -->
    <el-main id="main" class="main">
      <Breadcrumb></Breadcrumb>
      <!-- 表格 -->
      <div class="table">
        <el-table
          :data="tableData"
          border
          style="width: 100%"
          :default-sort="{ prop: 'date', order: 'descending' }"
        >
          <el-table-column fixed prop="id" label="ID"> </el-table-column>
          <el-table-column prop="account_name" label="开户名"> </el-table-column>
          <el-table-column prop="card_number" label="卡号"> </el-table-column>
          <el-table-column prop="bank_name" label="开户行"> </el-table-column>
          <el-table-column prop="sub_branch_name" label="开户支行"> </el-table-column>
          <el-table-column prop="create_time" label="创建时间"> </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button @click="del(scope)" icon="el-icon-delete"> 删除 </el-button
              ><br />
              <!-- <el-button @click="xiu(scope.$index)" icon="el-icon-edit">
              修改
            </el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div>
        <el-popover
          placement="left"
          width="780px"
          trigger="manual"
          :offset="300"
          v-model="visibles"
          ><br /><br />
          <div class="spbiao">
            开户银行：
            <el-input
              v-model="yinhang"
              placeholder="请输入开户银行"
              style="width: 300px"
            ></el-input
            ><br />
            <br />
            开户账号：
            <el-input
              v-model="zhanghao"
              placeholder="请输入开户账号"
              style="width: 300px"
            ></el-input
            ><br /><br />
            开户支行：
            <el-input
              v-model="zhihang"
              placeholder="请输入具体支行"
              style="width: 300px"
            ></el-input
            ><br /><br />
            开户名称：
            <el-input
              v-model="huming"
              placeholder="请输入开户名"
              style="width: 300px"
            ></el-input
            ><br /><br />
            <el-button type="success" @click="ok">确定</el-button>
            <el-button :plain="true" @click="no">取消</el-button>
          </div>
        </el-popover>
      </div>
      <!-- <Pagination></Pagination> -->

      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[100, 300, 500]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      <!-- /End 分页 -->
    </el-main>
    <!-- /End 内容区域 -->
  </div>
</template>

<script>
// import axios from "axios";
// import { Loading } from "element-ui";
export default {
  name: "bankcard",
  data() {
    return {
      start: "",
      end: "",
      input: "",
      cardinput: "",
      nameinput: "",
      gridData: [],
      yinhang: "", //开户银行
      zhanghao: "", //开户账号
      zhihang: "", //开户支行
      huming: "", //开户名
      myInstance: null, // axios实例
      tableData: [], // 表格数据
      visibles: false, //添加银行卡
      currentPage: 1, // 当前页码
      total: 0, // 总条目数
      query: "", // 查询参数
      pagenum: 1, // 当前页码
      pagesize: 100, // 每页显示条数
      imge: "",
      shopname: "",
      cardid: "",
      kaname: "",
      money_order: "", //额度排序
      moneyfee_order: "", //服务费排序
      order_id: "",
      options: [
        {
          value: "选项1",
          label: "新开卡",
        },
        {
          value: "选项2",
          label: "纠错",
        },
        // {
        //   value: "选项3",
        //   label: "微信",
        // },
        // {
        //   value: "选项4",
        //   label: "现金",
        // },
      ],
      dptype: "", //店铺类型
      newlist: [],
      timer: "", //计时器
      pwidth: 0, //公告文本的宽度
      value: 0,
      gg: "",
      i: "",
      titleStr: "",
      // windowWidth:'', // box宽度
      windowWidth: document.documentElement.clientWidth / 2.5, // 设备屏幕的宽度
    };
  },
  mounted() {
    let element = this.$refs.cmdlist;
    this.pwidth = document.defaultView.getComputedStyle(element, "").width.split("px");
    this.timer = setInterval(this.clickCommend, 20);
    this.getUser();
    this.shopname = localStorage.getItem("shopname");
    this.imge = localStorage.getItem("imge");
    var type_id = localStorage.getItem("type_id");
    if (type_id == 3) {
      this.dptype = "易货店";
    } else if (type_id == 5) {
      this.dptype = "折扣仓";
    }
    this.$axios.post(this.$api.new, {}).then((res) => {
      if (res.code == 1) {
        this.newlist = res.data;
        this.gg = this.newlist[0].title;
        this.i = 0
      }
    });
    // this.$axios.post(this.$api.shopinfo, {}).then((res) => {
    //   if (res.code == 1) {
    //     console.log(res.data.shop_name);
    //     this.shopname = res.data.shop_name;
    //     this.imge = res.data.logo;
    //     // this.sdyingshou = res.data.total_price
    //     // this.sdshishou = res.data.total_price
    //   }
    // });
  },
  watch: {
    value(newValue) {
      let allWidth = parseInt(this.windowWidth) + parseInt(this.pwidth[0]);
      // console.log(oldValue);
      if (newValue <= -allWidth) {
        this.$refs.cmdlist.style.marginLeft = this.windowWidth + "px";
        this.value = 0;
      }
    },
  },
  methods: {
    clickCommend() {
      // console.log(e);
      let _this = this;
      this.$nextTick(() => {
        this.value -= 1;
        this.$refs.cmdlist.style.marginLeft = _this.windowWidth + this.value + "px";
      });
    },
    menter() {
      clearInterval(this.timer);
    },
    mleave() {
      this.timer = setInterval(this.clickCommend, 20);
    },
    beforeDestroy() {
      clearInterval(this.timer);
    },
    detail(i) {
      this.$router.push({
        name: "proinfo",
        params: { details: this.newlist[i].details, title: this.newlist[i].title },
      });
    },
    del(strs) {
      //删除某行
      console.log(strs.$index);
      console.log(strs.row.id);
      this.$confirm("请您确定删除银行卡, 是否继续?", "提示", {
        //弹框确定继续操作
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$axios
            .post(this.$api.delbank, {
              id: strs.row.id,
            })
            .then((res) => {
              if (res.code == 1) {
                this.tableData.splice(strs.$index, 1);
                this.$message({
                  message: res.msg,
                  type: "success",
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    getUser() {
      this.$axios
        .post(this.$api.bank, {
          card_number: this.cardinput, // 查询参数
          //   account: this.input,
          //   nickname: this.nameinput,
          //   page: this.pagenum, // 当前页码
          //   page_size: this.pagesize, // 每页显示条数
          //   money_order: this.money_order,
          //   moneyfee_order: this.moneyfee_order,
        })
        .then((res) => {
          this.tableData = res.data; // 表格数据
        });
    },
    add() {
      this.visibles = true;
    },
    handleSizeChange(val) {
      //改变时
      this.pagesize = val;
      this.getUser();
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      //条目改变时
      this.pagenum = val;
      this.getUser();
      console.log(`当前页: ${val}`);
    },
    ok() {
      //确定添加银行卡
      this.$confirm("请您确定添加银行卡, 是否继续?", "提示", {
        //弹框确定继续操作
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$axios
            .post(this.$api.addbank, {
              account_name: this.huming,
              card_number: this.zhanghao,
              bank_name: this.yinhang,
              sub_branch_name: this.zhihang,
            })
            .then((res) => {
              if (res.code == 1) {
                //判断是否结算成功
                this.$message({
                  message: res.msg,
                  type: "success",
                });
                this.visibles = false;
                this.getUser();
                // location.reload() //刷新页面
              } else {
                this.$message({
                  message: res.msg,
                  type: "warning",
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
          this.visibles = false;
        });
    },

    no() {
      //取消添加
      this.$message({
        message: "取消添加",
        type: "warning",
      });
      this.visibles = false;
    },
  },
  computed: {},
};
</script>
<style scoped>
#box {
  width: 60%;
  vertical-align: middle;
  display: inline-block;
  margin-right: 5%;
  background: #50a3e5;
  color: #fff;
  white-space: nowrap;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
}
.marquee-box {
  overflow: auto;
}
#pWidth {
  width: 60%;
  height: 50px;
  padding: 0;
  margin: 0;
  line-height: 50px;
  display: block;
  word-break: keep-all;
  white-space: nowrap;
  overflow: hidden;
  font-family: 微软雅黑;
  font-size: 14px;
}
::-webkit-scrollbar {
  width: 0 !important;
}
::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}

.spbiao {
  width: 40%;
  left: 22%;
  min-height: 200px;
  position: fixed;
  background: #fff;
  border: 1px solid #ebeef5;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  word-break: break-all;
  top: 15%;
  padding: 5%;
}
.head {
  text-align: right;
  background: #50a3e5;
  color: white;
  padding: 10px;
  margin: 15px;
}
.touimg {
  width: 45px;
  height: 45px;
  vertical-align: middle;
  border-radius: 50%;
}
.spname {
  font-size: 18px;
  display: inline-block;
  margin-left: 15px;
}
h5 {
  display: inline-block;
  width: 30%;
}
.notice {
  width: 65%;
  height: 50px;
  top: 25px;
  left: 50%;
  transform: translate(-50%);
  position: absolute;
}
.notice /deep/ .el-card__body {
  padding: 0;
}
/*使文字和公告图片在一行*/
.notice_item {
  height: 50px;
  line-height: 50px;
  background: #50a3e5;
  color: white;
  white-space: nowrap;
  font-size: 14px;
  /* background-color: #fff; */
  display: flex;
  flex-direction: row;
  align-items: center;
}
.notice_item img {
  width: 40px;
  /*height: 16px;*/
  margin: 0 44px 0 32px;
}
.el-card {
  border: none;
}
</style>
